export default __webpack_public_path__ + "static/media/marauders-map-v4-04-02.d90a3548.jpg";